import * as yup from 'yup'

// Password: min 8, at least 1 uppercase, 1 special character
const passwordRegex = /^(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,}$/

export const loginSchema = yup.object({
  emailOrUserId: yup
    .string()
    .trim()
    .required('Email or User ID is required'),
  password: yup
    .string()
    .required('Password is required')
    .matches(passwordRegex, 'Password must be 8+ chars, 1 uppercase, 1 special'),
  keepLoggedIn: yup.boolean().default(false),
})

export type LoginFormValues = yup.InferType<typeof loginSchema>

export const newPasswordSchema = yup.object({
  password: yup
    .string()
    .required('Password is required')
    .matches(passwordRegex, 'Password must be 8+ chars, 1 uppercase, 1 special'),
  confirmPassword: yup
    .string()
    .required('Please confirm password')
    .oneOf([yup.ref('password')], 'Passwords must match'),
});

export type NewPasswordFormValues = yup.InferType<typeof newPasswordSchema>;